import React, { createContext, useReducer } from "react";
import { authReducer } from "./AuthReducer"


// ESTADO INICIAL 
export const authInitialState = {
    IdUser: 0,
    Usuario: '',
    UserName: '',
    Email: '',
    IdRol: 0,
    IdStatus: 0,
    isLogged: false,
    AccessWeb: '',
    PermissionMenu: '',
    Configuration: ''
}


export const AuthContext = createContext({});

// COMPONENTE PROVIDER DEL CONTEXTO
export const AuthProvider = ({children}) => { // children: JSX.Element puede ser type any

    const [userAuth, dispatch] = useReducer(authReducer, authInitialState, );

    const signIn = (Usuario) => {
        dispatch({type: 'signIn', payload: Usuario});
    }
    const signOut = () => {
        dispatch({type: 'signOut'});
    }

    const changePermisos = (permisos) => {
        
        dispatch({type: 'changePermisos', payload: permisos});
    }

    const changeAccesos = (permisos) => {
        dispatch({type: 'changeAccesos', payload: permisos});
    }

    const setIdPersonal = (idPersonal) => {
        dispatch({type: 'setIdPersonal', payload: idPersonal});
    }

   return (
    <AuthContext.Provider value={{ 
        userAuth,
        signIn,
        signOut,
        setIdPersonal,
        changePermisos,
        changeAccesos
     }}>
        {children}
    </AuthContext.Provider>
   );
}